import { useCallback } from 'react';
import { siteInfo } from '../data/mock';

export const useContactActions = (message) => {
  const phone = siteInfo.phone;
  const number = siteInfo.whatsapp.replace(/[^0-9]/g, '');
  const handleCallClick = useCallback(() => { window.location.href = `tel:${phone}`; }, [phone]);
  const handleWhatsAppClick = useCallback(() => {
    // The browser's encodeURIComponent is stable; track the actual contact value.
    window.open(`https://wa.me/${number}?text=${encodeURIComponent(message)}`, '_blank', 'noopener,noreferrer');
  }, [message, number]);
  return { handleWhatsAppClick, handleCallClick };
};